import React from 'react';

import { deepFindProperty } from 'components/PlateEditor/utils/deepFindProperty';

export const ListItemElement = (props) => {
  const { element, children, style: styleProp = {} } = props;

  const fontSize = deepFindProperty('fontSize', element);
  const fontFamily = deepFindProperty('fontFamily', element);
  const color = deepFindProperty('color', element);

  let style = styleProp;

  if (fontSize) {
    // Need to shift the list item element over if font size is above a certain size
    // so the bullet doesn't overlap with the content.
    const multiplier = Math.ceil(parseInt(fontSize, 10) / 30);
    const padding = multiplier * 5;

    style = {
      ...style,
      fontSize,
      ... multiplier > 1 && { paddingLeft: padding },
    };
  }

  if (fontFamily) {
    style = {
      ...style,
      fontFamily,
    };
  }

  if (color) {
    style = {
      ...style,
      color,
    };
  }

  return (
    <li
      style={style}
    >
      {children}
    </li>
  );
};
